//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defaultBlockProps } from "~/helpers/data";

export default {
    name: "BowCTABlock",

    props: {
        ...defaultBlockProps,

        type: {
            default: "left",
            type: String,
        },
    },

    data: () => ({}),

    // mounted() {
    //   if ( window.devicePixelRatio > 1 ) {
    //     const section = this.$el.closest('.b-section');

    //     if ( section ) {
    //       section.classList.remove('is-cta-block');
    //     }
    //   }
    // }
};
